import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { RecalculateInvoicePayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'INVOICE_RECALCULATE_',
  }
);

export interface InvoiceRecalculateState {
  data: any;
  loading: boolean;
  errorMessage: string | null;
}

export interface InvoiceRecalculateRequestAction {
  payload: RecalculateInvoicePayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: any;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: InvoiceRecalculateState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: InvoiceRecalculateState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: InvoiceRecalculateState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: InvoiceRecalculateState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: InvoiceRecalculateState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const invoiceRecalculate = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const InvoiceRecalculateTypes = Types;
export const InvoiceRecalculateActions = Creators;
